import React, { FC } from "react";
import { Field } from "react-final-form";
import { makeStyles, Theme } from "@material-ui/core";
import Autocomplete from "../../../components/Autocomplete";
import MajorField from "../../major/components/MajorField";
import DegreeField from "../../degree/components/DegreeField";
import { INTAKES, PROGRAM_TYPES } from "../../program/constants";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    marginTop: theme.spacing(3),
  },
}));

const AcademicsFilterFormHigher: FC = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.formControl}>
        <MajorField fullWidth name="major" label="Major" placeholder="Major" />
      </div>
      <div className={classes.formControl}>
        <DegreeField
          fullWidth
          name="degree"
          label="Degree"
          placeholder="Degree"
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="programType"
          label="Program Type"
          placeholder="Program Type"
          options={PROGRAM_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="intake"
          label="Intake"
          placeholder="Intake"
          options={INTAKES}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(AcademicsFilterFormHigher);
